export enum StorageKeys {
    Token = "sdp_token",
    RefreshToken = "sdp_refresh_token",
    Language = "sdp_language",
    Impersonate = "sdp_impersonate",
}
